module.exports = __webpack_public_path__ + "media/images/estacionamento-5506a865c6628ff8f9334c18630c159a.svg";